import SupportedBrowser from './SupportedBrowser';

export default SupportedBrowser;
